import { TablesByTagQuery } from '../../../../../../gen-src/queries';
import { getMaxDownstreamDatasources, getMaxDownstreamWorkbooks, MaxCountsResultData } from '../../../../data-catalog-shared';
import { DenormalizedTableRowData } from '../types/TablesDisplayGridRowData';

export function getRowDataWithMaxCountsForTable<T>(
  table: T,
  resultData: MaxCountsResultData | null,
): T & DenormalizedTableRowData {
  return {
    ...table,
    contentType: 'table',
    maxDownstreamDatasources: getMaxDownstreamDatasources(resultData),
    maxDownstreamWorkbooks: getMaxDownstreamWorkbooks(resultData),
  };
}

export function getRowDataWithMaxCountsForTableWithTagFilter<T>(
  table: T,
  resultData: TablesByTagQuery | null,
): T & DenormalizedTableRowData {
  const tag = resultData && resultData.tags && resultData.tags[0];
  return getRowDataWithMaxCountsForTable(table, tag);
}
